<template>
  <div>
    <el-button
      @click="clickHandel"
      :disabled="disabled"
      type="primary"
      :style="{'top':top?top+'px':''}"
      class="verification_code"
    >{{text}}</el-button>
  </div>
</template>

<script>
import { setInterval, clearInterval } from "timers";
import { regexp } from "@/utils";
import { commonRes } from "@/api";
export default {
  props: {
    top: {
      type: Number,
      default: 0
    },
    text: {
      type: String,
      default: "获取验证码"
    },
    value: {
      type: String,
      default: ""
    },
    endTime: {
      type: Number,
      default: 60
    },
    // 1:注册,2:登录,3:修改密码,4:忘记密码,5:重置密码
    sendType:{
       type:Number,
        default:1    
    }
  },
  data() {
    return {
      disabled: false
    };
  },
  methods: {
    clickHandel() {
      // 校验邮箱验证不为空,且符合邮箱格式
      if (!this.value || !regexp.email.test(this.value)) {
        this.$message.error("请输入正确格式的邮箱号");
        return false;
      }
      const {sendType,value} = this
      commonRes.getEmailCaptcha({type:sendType,email:value}).then(res => {
        this.$message.success("邮箱验证码已发送,请前往邮箱查看");
        this.startTimer();
      });
    },
    startTimer() {
      let end = this.endTime;
      const v1 = setInterval(() => {
        this.disabled = true;
        end--;
        this.text = end + "s重新获取";
        if (end == 0) {
          clearInterval(v1);
          this.disabled = false;
          this.text = "获取验证码";
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss">
.verification_code {
  height: 31px;
  padding: 0 10px;
  position: relative;
}
</style>
